// The shared option-colour palette (Asana-style). Keys are what persist in the
// DB — custom-field option colours and task-project colours both draw from this
// list. The colours themselves live as theme-aware `--cf-color-<key>-bg`/`-text`
// /`-solid` tokens in the client's tokens.scss, so nothing here is a hex value.
//
// Lives in common/ because the server assigns a colour when a project is created
// without one, and the client renders swatches from the same keys.
export const OPTION_COLOR_KEYS = [
  'red',
  'orange',
  'yellow-orange',
  'yellow',
  'yellow-green',
  'green',
  'blue-green',
  'aqua',
  'blue',
  'indigo',
  'purple',
  'magenta',
  'hot-pink',
  'cool-gray',
] as const

export type OptionColorKey = (typeof OPTION_COLOR_KEYS)[number]

export const DEFAULT_OPTION_COLOR: OptionColorKey = OPTION_COLOR_KEYS[0]

const OPTION_COLOR_KEY_SET: ReadonlySet<string> = new Set(OPTION_COLOR_KEYS)

export const isOptionColorKey = (key: unknown): key is OptionColorKey =>
  typeof key === 'string' && OPTION_COLOR_KEY_SET.has(key)

/**
 * Pick a colour for a new item: the first key nothing else is using, else cycle
 * by `index` so the palette repeats in a stable order once all 14 are taken.
 */
export const pickNextOptionColor = (takenColors: Iterable<string>, index = 0): OptionColorKey => {
  const taken = new Set(takenColors)
  return (
    OPTION_COLOR_KEYS.find((key) => !taken.has(key)) ??
    OPTION_COLOR_KEYS[index % OPTION_COLOR_KEYS.length]
  )
}
